module.exports = __webpack_public_path__ + "static/media/act_alrt-1.0abecc86.mp4";